import { Box, FormControl, Typography } from "@mui/material";
import {
  CommonButton,
  CommonOutlinedButton,
  CustomMenuItem,
  CustomRequiredInputLabel,
  CustomSelect,
  CustomTextFeild,
} from "../../common/StyledComponents/StyledFields";
import { useEffect, useState } from "react";
import { object, string } from "yup";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { ClipLoader } from "react-spinners";
import commonStyles from "../../../App.module.scss";
import {
  apiRequest,
  catchErrorMessageHandler,
} from "../../../infrastructure/backendService";
import apiPath from "../../../config/apiPaths.json";
import ErrorPopup from "../../common/ErrorPopup";
import toast from "react-hot-toast";
import constants from "../../../config/constants.json";
import tableStyles from "./RefundToDevotee.module.scss";
import SuccessPopup from "../../devotee/donation/successPopup";

interface PropsType {
  onClose: () => void;
  selectedTable: any;
}

const RefundToDevotee: React.FC<PropsType> = (props) => {
  const { selectedTable } = props;
  const [hallBookingData, setHallBookingData] = useState<any>(null);
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const [formData, setFormData] = useState({
    // referenceNumber: "",
    reasonforrefund: "",
    checkNumber: "",
    refundMode: "",
  });

  const allowedReferenceNumbers =
    hallBookingData?.contractFormTransactions?.map(
      (each: any) => each.referenceNumber
    ) || [];
  const validationSchema = object().shape({
    // referenceNumber: string()
    //   .required("Reference Number is required")
    //   .matches(/^[0-9]+$/, "Reference Number must be a number")
    //   .oneOf(allowedReferenceNumbers, "Invalid Reference Number"),
    checkNumber:
      formData.refundMode !== "5"
        ? string()
        : string()
            .required("Check Number is required")
            .matches(/^[0-9]+$/, "Reference Number must be a number"),
    reasonforrefund: string().required("Reason for refund"),
    refundMode: string().required("Type of refund amount required"),
  });

  const [refundButton, setRefundButton] = useState(true);

  const [cancelDisable, setCancelDisable] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);

  const [errorMessage, setErrorMessage] = useState({
    // referenceNumber: "",
    checkNumber: "",
    reasonforrefund: "",
    refundMode: "",
  });

  const typeofRefundType = [
    {
      label: "Cash",
      id: "26",
    },
    {
      label: "Check",
      id: "5",
    },
    // {
    //   label: "Credit Card",
    //   id: "20",
    // },
  ];

  useEffect(() => {
    getBookingHallsDataByID();
  }, [selectedTable]);

  const getBookingHallsDataByID = () => {
    apiRequest({
      method: "GET",
      endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${selectedTable?.id}/contracts/${selectedTable?.hallContractFormId}`,
      includeToken: true,
    })
      .then((res: any) => {
        setHallBookingData(res?.data);
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
      });
  };

  const handleFieldChange = (field: string, value: any) => {
    setRefundButton(false);
    setFormData({
      ...formData,
      [field]: value,
    });
  };

  const handleErrorMessages = (field: string, value: any) => {};

  const submitHandleRefund = () => {
    setCancelDisable(true);
    setLoading(true);
    const payload = {
      onBehalfOfUsername: hallBookingData?.devoteeUsername,
      receiptNumber: selectedTable?.receiptId,
      refundReason: formData.reasonforrefund,
      refundAmount: Math.abs(selectedTable?.additionalData?.settlementAmount),
      checkNumber: formData.checkNumber,
      refundType: "D",
    };
    apiRequest({
      method: "POST",
      endpoint: `${apiPath.contractFormHallBookingManagerFlow}/${selectedTable?.id}/contracts/${selectedTable?.hallContractFormId}/closure`,
      includeToken: true,
      body: JSON.stringify(payload),
    })
      .then((res) => {
        toast.custom(
          <SuccessPopup
            headerMessage="Refunded Successfully!"
            showMessage={"Refunded Successfully!"}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        props.onClose();
        setLoading(false);
        setRefundButton(true);
        setCancelDisable(false);
        setFormData({
          // referenceNumber: "",
          reasonforrefund: "",
          checkNumber: "",
          refundMode: "",
        });
      })
      .catch((err) => {
        toast.custom(
          <ErrorPopup
            showMessage={catchErrorMessageHandler(err)}
            isOpen={isOpen}
            setIsOpen={setIsOpen}
          />,
          {
            duration: constants.TOAST_POPUP_DURATION,
          }
        );
        setLoading(false);
        setRefundButton(true);
        setCancelDisable(false);
      });
  };

  const handleRefund = async () => {
    const errors = {
      // referenceNumber: "",
      checkNumber: "",
      reasonforrefund: "",
      refundMode: "",
    };

    validationSchema
      .validate(formData, { abortEarly: false })
      .then(() => {
        setErrorMessage(errors);
        submitHandleRefund();
      })
      .catch((errors: any) => {
        // Validation failed, handle errors
        setErrorMessage(
          errors.inner.reduce((acc: any, error: any) => {
            acc[error.path] = error.message;
            return acc;
          }, {})
        );
      });
  };

  const handleCancel = () => {
    props.onClose();
    setFormData({
      // referenceNumber: "",
      reasonforrefund: "",
      checkNumber: "",
      refundMode: "",
    });
  };

  const getLabelTextBox = (props: any) => {
    const {
      labelName,
      readOnly,
      value,
      required,
      placeholder,
      marginRight,
      field,
    } = props;
    return (
      <Box sx={{ mt: "20px", marginRight: marginRight }}>
        {CustomRequiredInputLabel(labelName, required)}
        <CustomTextFeild
          value={value}
          required
          onChange={(e) => {
            handleFieldChange(field, e.target.value);
            setErrorMessage({ ...errorMessage, [field]: "" });
          }}
          onBlur={(e) => handleErrorMessages(field, e.target.value)}
          placeholder={placeholder}
          sx={{
            border: "1px solid rgba(136, 46, 20, 0.40)",
            borderRadius: "8px",
          }}
          InputProps={{
            readOnly: readOnly,
          }}
        />
        {errorMessage?.[field as keyof typeof errorMessage] ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage?.[field as keyof typeof errorMessage]}
          </Typography>
        ) : (
          ""
        )}
      </Box>
    );
  };

  const RefundAmountType = (): React.ReactElement => {
    return (
      <FormControl sx={{ width: "100%" }}>
        <CustomSelect
          IconComponent={KeyboardArrowDownIcon}
          placeholder="Select Pooja Location"
          value={formData.refundMode}
          id="grouped-select"
          onChange={(e) => {
            handleFieldChange("refundMode", e.target.value);
            setErrorMessage({ ...errorMessage, refundMode: "" });
          }}
          MenuProps={{
            PaperProps: {
              sx: {
                border: "1px solid #F05802",
                "& ul": {
                  paddingTop: 0,
                  paddingBottom: 0,
                  overflowY: "auto",
                  minHeight: "auto",
                  maxHeight: "300px",
                  "&::-webkit-scrollbar": {
                    width: "8px",
                  },
                  "&::-webkit-scrollbar-thumb": {
                    background: "#F3C539",
                    borderRadius: "6px",
                  },
                },
              },
            },
          }}
          sx={{
            width: "228px",
            border: "1px solid rgba(136, 46, 20, 0.40)",
            borderRadius: "8px",
          }}
        >
          {typeofRefundType.map((item, index: number) => (
            <CustomMenuItem key={index} value={item.id}>
              {item.label}
            </CustomMenuItem>
          ))}
        </CustomSelect>
        {errorMessage.refundMode ? (
          <Typography sx={{ color: "red", fontSize: "12px" }}>
            {errorMessage.refundMode}
          </Typography>
        ) : (
          ""
        )}
      </FormControl>
    );
  };

  const handleButtons = () => {
    return (
      <Box sx={{ mt: "20px" }}>
        <CommonOutlinedButton
          className={commonStyles.cancelButton}
          onClick={handleCancel}
          disabled={cancelDisable}
        >
          Cancel
        </CommonOutlinedButton>
        <CommonButton
          className={commonStyles.saveButton}
          sx={{ marginLeft: "16px" }}
          onClick={handleRefund}
          disabled={refundButton}
        >
          {loading ? (
            <>
              <ClipLoader color="#fff" loading={loading} size={15} />
              <span
                style={{
                  marginLeft: "8px",
                  fontSize: "15px",
                  textAlign: "center",
                }}
              >
                Please wait...
              </span>
            </>
          ) : (
            "Refund"
          )}
        </CommonButton>
      </Box>
    );
  };

  const renderReferenceNumberTable = () => {
    return (
      <Box sx={{ mt: "20px" }}>
        <Typography
          sx={{
            color: "#414141",
            fontFamily: "Lato",
            fontSize: "16px",
            fontWeight: 600,
            lineHeight: "140%",
          }}
        >
          Reference Numbers
        </Typography>
        <table className={tableStyles.tableContainer}>
          <thead>
            <tr className={tableStyles.headerTableRow}>
              <th className={tableStyles.tableHorizontal}>Reference Number</th>
              <th className={tableStyles.tableHorizontal}>
                Date of Transaction
              </th>
              <th className={tableStyles.tableHorizontal}>Amount Transacted</th>
            </tr>
          </thead>
          <tbody>
            {hallBookingData?.contractFormTransactions?.map(
              (data: any, index: number) => (
                <tr className={tableStyles.tableRow} key={index}>
                  <td className={tableStyles.tableDiagonal}>
                    {data?.referenceNumber}
                  </td>
                  <td className={tableStyles.tableDiagonal}>
                    {data?.dateOfTransaction}
                  </td>
                  <td className={tableStyles.tableDiagonal}>
                    {data?.amountTransacted}
                  </td>
                </tr>
              )
            )}
          </tbody>
        </table>
      </Box>
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "8px",
        boxShadow: "0px 2px 20px 0px rgba(237, 237, 237, 0.8)",
      }}
    >
      <Box
        sx={{
          padding: "25px",
        }}
      >
        <Typography
          sx={{
            color: "#414141",
            fontFamily: "Lato",
            fontSize: "24px",
            fontWeight: 600,
            lineHeight: "140%",
          }}
        >
          Refund to Devotee
        </Typography>
        <Box
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          {getLabelTextBox({
            labelName: "Name",
            required: true,
            value: hallBookingData?.devoteeFullname,
            readOnly: true,
            placeholder: "Name",
            marginRight: "20px",
          })}
          {getLabelTextBox({
            labelName: "Refund Amount",
            required: true,
            value: Math.abs(selectedTable?.additionalData?.settlementAmount),
            placeholder: "Enter Refund Amount",
            readOnly: true,
          })}
        </Box>
        <Box
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          {getLabelTextBox({
            labelName: "Receipt ID",
            required: true,
            value: selectedTable?.receiptId,
            placeholder: "Enter Receipt ID",
            marginRight: "20px",
            field: "receiptId",
            readOnly: true
          })}
          <Box mt="20px">
            {CustomRequiredInputLabel("Type of Refund Amount", true)}
            {RefundAmountType()}
          </Box>
        </Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", md: "row" },
          }}
        >
          {getLabelTextBox({
            labelName: "Check Number",
            required: formData.refundMode === "5",
            value: formData.checkNumber,
            placeholder: "Enter Check Number",
            field: "checkNumber",
            marginRight: "20px",
            readOnly: formData.refundMode !== "5",
          })}
          {getLabelTextBox({
            labelName: "Reason for Refund",
            required: true,
            value: formData.reasonforrefund,
            placeholder: "Reason for Refund",
            field: "reasonforrefund",
          })}
        </Box>
        {/* {renderReferenceNumberTable()} */}
        {handleButtons()}
      </Box>
    </Box>
  );
};

export default RefundToDevotee;
